import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from "../../environments/environment";
import { Absence, AbsenceReason, AbsenceUserHash } from "../_models/absence.interface";


@Injectable({
  providedIn: 'root'
})
export class AbsenceService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public getUsers() {
    const path = environment.apiURL + 'absence_io/users'
    return this.http.get<AbsenceUserHash[]>(path)
  }

  public getAbsenceReason(id: string) {
    const path = environment.apiURL + 'absence_io/reasons/' + id;
    return this.http.get<AbsenceReason>(path)
  }

  public getAbsencesInDateInterval(date_start: string, date_end: string) {
    const path = environment.apiURL + 'absence_io/absences';

    let params = new HttpParams()
    params = params.append('date_start', date_start)
    params = params.append('date_end', date_end)

    return this.http.get<Absence[]>(path, { params })
  }

}

